import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import {logout} from './../../redux/modules/auth';
import {push} from 'react-router-redux';
import styles from './../MenuBar/MenuBar.less';
import * as changePasswordActions  from './../../actions/changePasswordActions';
import * as commonActions from './../../actions/commonActions';
import {Button, ButtonToolbar} from 'react-bootstrap';
import i18next from 'i18next';
import { applyStyleapplyToHover, getSelectedDate, setDirection } from './../../utils/utils';

const elementsData = [
  {"classNames":"profileButton", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"inputField", "elementType":"normal", "applyTo":"all", "tagNames":"input"}
]
const directionData = [
  {"classNames":"profileButtonDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"row_Content", "elementType":"normal", "applyTo":"all", "tagNames":"div"}
]
@connect(state => ({
  resetmessage:state.dashboardRoot.changePasswordReducer.message,
 // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang
  }), {
  logout,
  pushState: push,
   ...changePasswordActions,
   ...commonActions
})

export default class ChangePasswordSettingComponent extends Component {

  static propTypes = {
    resetmessage: PropTypes.string,
    blankMsg:PropTypes.func,
    changePasswordSetting: PropTypes.func
  }

  state = {
    errorFlag:false,
    errorMsg:'',
    success_msg:'',
    //States to track changes in old password, new password and confirm new password fields
    oldPwd:'',
    newPwd:'',
    confirmNewPwd:''
  }

  componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
   // //const allCssStyleRules = this.props.selectedCssColorTheme;
   // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(thisComponent,directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("profileButton")[0], "classNames":"profileButton"},
        {"elmToHover":thisComponent.getElementsByClassName("profileButton")[1], "classNames":"profileButton"},
    ];
  //  //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    this.setState({success_msg:''});
  }

  componentWillReceiveProps(nextProps, nextState){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if(this.props.resetmessage !== nextProps.resetmessage){ 
      if(nextProps.resetmessage === i18next.t('pwdResetSuccessMsg')){
        this.setState({success_msg: nextProps.resetmessage});
      }
      else{
        this.setState({errorFlag: true, errorMsg: nextProps.resetmessage});
      }
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
  }

  // Handler to set states with updated values for old password,new password
  // and confirm new password fields as they change
  passwordChangeHandler = (event) =>{
    try{
      this.setState({[event.target.name]: event.target.value.trim()});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'passwordChangeHandler', component:"ChangePasswordSettingComponent"});
    }
  }

  //Resets field and error states
  clearFields = () =>{
    try{
      this.setState({
        oldPwd: '',
        newPwd: '',
        confirmNewPwd: '',
        errorFlag:false,
        errorMsg:'',
        success_msg: ''
      });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'clearFields', component:"ChangePasswordSettingComponent"});
    }
  }

  handleSubmit = (event) => {
    try{
      var oldpassInput = this.state.oldPwd.trim();
      var newpassInput = this.state.newPwd.trim();
      var confpassInput = this.state.confirmNewPwd.trim();

      var location = localStorage.getItem('location');
      if(oldpassInput === '' ){
        this.setState({errorFlag :true});
        this.setState({errorMsg :i18next.t('oldPwdNotBlankMsg')});
      } else if(newpassInput === '' || confpassInput  === ''){
        this.setState({errorFlag :true});
        this.setState({errorMsg :i18next.t('newPwdNotBlankMsg')});
      } else if(newpassInput !== confpassInput){
        this.setState({errorFlag :true});
        this.setState({errorMsg :i18next.t('newPwdNotMatchMsg')});
      } else if(oldpassInput === newpassInput ){
        this.setState({errorFlag :true});
        this.setState({errorMsg :i18next.t('pwdNotSameAsOldPwdMsg')});
      } else if(!newpassInput.match(/^(?=.*[A-Za-z&@!#$])(?=.*\d)[A-Za-z&@!#$\d]{8,16}$/)){
        this.setState({errorFlag :true});
        this.setState({errorMsg :i18next.t('minMaxPwdLength')});
      } else{
          this.setState({errorFlag :false, errorMsg: '', });
          const resetPass = {oldpass: oldpassInput,  newpass: newpassInput,  location: location};
          this.props.changePasswordSetting(resetPass);
          this.clearFields();
      }

      this.setState({
        oldPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleSubmit', component:"ChangePasswordSettingComponent"});
    }
  }

  showError = () => {
    try{
      if (this.state.errorFlag && this.state.errorMsg !== '') {
        return(
          <p style={{marginTop: 10, textAlignLast: 'center', color: 'red', fontSize: 12, fontWeight: 600,textTransform: 'initial'}}>{this.state.errorMsg}</p>
        );
      } else if (this.state.success_msg !== "" && this.state.success_msg === i18next.t('pwdResetSuccessMsg')) {
        return (
          <p style={{marginTop: 10, textAlignLast: 'center', color: 'green', fontSize: 12, fontWeight: 600,textTransform: 'initial'}}>{i18next.t('pwdResetSuccessMsg')}</p>
        );
      } else {
        return null;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showError', component:"ChangePasswordSettingComponent"});
    }
  }

  render(){
      return(
        <div>
          <form>
            <div className={`${styles.widgetBody}`}>
              <div className={`${styles.wrpRow}`}>
                  <div className={`${styles.row_Content} row_Content`}>
                    <p>{i18next.t('oldPwd')}</p>
                  </div>
                  <div className={`${styles.row_Content}`}>
                    <input type="password"
                      value={this.state.oldPwd}
                      id="oldPwd" name="oldPwd" onChange={this.passwordChangeHandler}
                      placeholder={i18next.t('oldPwd')} className="form-control inputField" required="required"/>
                  </div>
              </div>
              <div className={`${styles.wrpRow}`}>
                  <div className={`${styles.row_Content} row_Content`}>
                    <p>{i18next.t('newPwd')}</p>
                  </div>
                  <div className={`${styles.row_Content}`}>
                    <input type="password"
                      value={this.state.newPwd}
                      id="newPwd" name="newPwd" onChange={this.passwordChangeHandler}
                      placeholder={i18next.t('newPwd')} className="form-control inputField" required="required"/>
                  </div>
              </div>
              <div className={`${styles.wrpRow}`}>
                  <div className={`${styles.row_Content} row_Content`}>
                    <p>{i18next.t('confirmPwd')}</p>
                  </div>
                  <div className={`${styles.row_Content}`}>
                    <input type="password"
                      value={this.state.confirmNewPwd}
                      id="confirmNewPwd" name="confirmNewPwd" onChange={this.passwordChangeHandler}
                      placeholder={i18next.t('confirmPwd')} className="form-control inputField" required="required"/>
                  </div>
              </div>
              {this.showError()}
              <div className={`${styles.button_Content} col-md-12 profileButtonDiv`}>
                     <Button className={`${styles.savebutton} col-auto`} onClick={this.handleSubmit}>{i18next.t('save')}</Button>
                     <Button className={`${styles.clearbutton} col-auto clearBtn`} onClick={this.clearFields}>{i18next.t('clear')}</Button>

              </div>
            </div>
          </form>
        </div>
      );
    }
}
